<template>
  <div class="resume">
    <Resume class="left" :resume="resume"></Resume>
    <div class="right">
      <icon @click.native="handleCloce" class="icon" type="guanbi" color="#fff"></icon>
      <div class="dzh" @click="startChat">打招呼</div>
      <div v-if="!resume.is_collect" @click="setStar(1)">收藏人才</div>
      <div v-else @click="setStar(0)">取消收藏</div>
    </div>
  </div>
</template>

<script>
import Resume from "_c/resume/resume";

export default {
  name: "",
  props: {
    resume: {
      type: Object
    }
  },
  methods: {
    handleCloce() {
      this.$emit("closePopup");
    },
    setStar(status) {
      let data = {
        user_id: this.resume.user_id,
        check: 1
      };
      if (status) {
        this.$axios
          .request({
            url: "api/qiye/companyCollection/add",
            method: "post",
            data
          })
          .then(res => {
            if (res.success) {
              this.$set(this.resume, "is_collect", 1);
              this.$Notice.success({
                title: "收藏成功"
              });
            }
          });
      } else {
        this.$axios
          .request({
            url: "api/qiye/companyCollection/" + this.resume.user_id,
            method: "delete"
          })
          .then(res => {
            this.$Notice.success({
              title: "取消收藏成功"
            });
            this.resume.is_collect = null;
          });
      }
    },
    startChat() {
      this.$axios
        .request({
          url: "api/qiuzhi/message/send",
          method: "post",
          data: { to: this.resume.user_id, job_id: 0 }
        })
        .then(res => {
          // if (res.data.to_user_id) {
          //   this.$store.dispatch(
          //     "checkoutConversation",
          //     TIM.TYPES.CONV_C2C + res.data.to_user_id
          //   );
          // }
        });
    }
  },
  components: { Resume }
};
</script>

<style lang="less" scoped>
.resume {
  width: 100%;
  display: flex;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  > .left {
    width: 80%;
  }
  .right {
    width: 20%;
    position: relative;
    padding: 20px 38px;
    > .icon {
      margin-left: 100%;
      padding: 4px;
      background: #363e4f;
      border-radius: 50%;
      opacity: 0.4;
      cursor: pointer;
    }
    > div {
      width: 100%;
      height: 36px;
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
    .dzh {
      margin-top: 48px;
      background-color: #d6000f;
      color: #fff;
    }
    div:last-child {
      margin-top: 20px;
      color: #d6000f;
      border: 1px solid #d6000f;
    }
  }
}
</style>
